module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectProduct",
    class: {
      required: _vm.item && !!_vm.item.required && ['finishedProduct', 'materiel'].indexOf(_vm.fieldAttr) === -1
    }
  }, [(_vm.fieldAttr === 'products') ? [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.nonEditable === 1 || _vm.slectProBtn
    },
    on: {
      "click": function($event) {
        _vm.handleSelect()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("选择产品\n     ")]), _vm._v(" "), _c('scan-code', {
    attrs: {
      "slectProBtn": _vm.nonEditable === 1 || _vm.slectProBtn,
      "fieldAttr": _vm.fieldAttr,
      "barcodeParams": _vm.barcodeParams
    },
    on: {
      "getProduct": _vm.handleSelect,
      "sendProduct": _vm.scancCodePro
    }
  })] : _vm._e(), _vm._v(" "), (_vm.moduleName === 'assemble') ? [(_vm.fieldAttr === 'outProducts') ? [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.nonEditable === 1 || _vm.getDisabled(_vm.fieldAttr)
    },
    on: {
      "click": function($event) {
        _vm.handleSelect()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("选择产品\n       ")]), _vm._v(" "), _c('scan-code', {
    attrs: {
      "slectProBtn": _vm.nonEditable === 1 || _vm.getDisabled(_vm.fieldAttr),
      "fieldAttr": _vm.fieldAttr,
      "barcodeParams": _vm.barcodeParams
    },
    on: {
      "getProduct": _vm.handleSelect,
      "sendProduct": _vm.scancCodePro
    }
  })] : [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.nonEditable === 1 || _vm.getDisabled(_vm.fieldAttr)
    },
    on: {
      "click": function($event) {
        _vm.handleSelect()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("选择产品\n       ")]), _vm._v(" "), _c('scan-code', {
    attrs: {
      "slectProBtn": _vm.nonEditable === 1 || _vm.getDisabled(_vm.fieldAttr),
      "fieldAttr": _vm.fieldAttr,
      "barcodeParams": _vm.barcodeParams
    },
    on: {
      "getProduct": _vm.handleSelect,
      "sendProduct": _vm.scancCodePro
    }
  })]] : _vm._e(), _vm._v(" "), (_vm.moduleName === 'bomBill') ? [(_vm.fieldAttr === 'finishedProduct') ? [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.nonEditable === 1 || _vm.getDisabled(_vm.fieldAttr)
    },
    on: {
      "click": function($event) {
        _vm.handleSelect()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("选择产品\n       ")]), _vm._v(" "), _c('scan-code', {
    attrs: {
      "slectProBtn": _vm.nonEditable === 1 || _vm.getDisabled(_vm.fieldAttr),
      "fieldAttr": _vm.fieldAttr,
      "barcodeParams": _vm.barcodeParams
    },
    on: {
      "getProduct": _vm.handleSelect,
      "sendProduct": _vm.scancCodePro
    }
  })] : [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.nonEditable === 1 || _vm.getDisabled(_vm.fieldAttr)
    },
    on: {
      "click": function($event) {
        _vm.handleSelect()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("选择产品\n       ")]), _vm._v(" "), _c('scan-code', {
    attrs: {
      "slectProBtn": _vm.nonEditable === 1 || _vm.getDisabled(_vm.fieldAttr),
      "fieldAttr": _vm.fieldAttr,
      "barcodeParams": _vm.barcodeParams
    },
    on: {
      "getProduct": _vm.handleSelect,
      "sendProduct": _vm.scancCodePro
    }
  })]] : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择产品",
      "visible": _vm.dialogVisible,
      "modal": _vm.modal,
      "lock-scroll": false,
      "width": "750px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "contentL"
  }, [(_vm.showClassify) ? [_c('span', [_vm._v("产品分类：")]), _vm._v(" "), _c('products-type', {
    on: {
      "refresh": _vm.getProList
    }
  })] : _vm._e(), _vm._v(" "), _c('span', [_vm._v("搜索：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "prefix-icon": "el-icon-search",
      "placeholder": "搜索产品"
    },
    on: {
      "change": _vm.handleSearch
    },
    model: {
      value: (_vm.nameOrNoOrSpecLike),
      callback: function($$v) {
        _vm.nameOrNoOrSpecLike = $$v
      },
      expression: "nameOrNoOrSpecLike"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tableOut"
  }, [_c('table', {
    staticClass: "selfTable",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("选择")]), _vm._v(" "), _c('th', [_vm._v("图片")]), _vm._v(" "), _c('th', [_vm._v("产品名称")]), _vm._v(" "), _c('th', [_vm._v("编号")]), _vm._v(" "), (_vm.moduleName !== 'supplier') ? _c('th', [_vm._v("规格")]) : _vm._e(), _vm._v(" "), (_vm.moduleName === 'supplier') ? _c('th', [_vm._v("成本价(元)")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("售价(元)")]), _vm._v(" "), _c('th', [_vm._v("单位")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.productList), function(item, index) {
    return [_c('tr', {
      key: item.id
    }, [_c('td', [_c('el-checkbox', {
      on: {
        "change": function($event) {
          _vm.selectPro(item)
        }
      },
      model: {
        value: (item.inputChecked),
        callback: function($$v) {
          _vm.$set(item, "inputChecked", $$v)
        },
        expression: "item.inputChecked"
      }
    })], 1), _vm._v(" "), _c('td', [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "height": "48",
        "width": "48"
      },
      on: {
        "click": function($event) {
          _vm.imgBig(item.thumbnail)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "disabled": item.productName.length > 10 ? false : true,
        "effect": "dark",
        "content": item.productName,
        "placement": "top"
      }
    }, [_c('p', [_vm._v(_vm._s(item.productName))])])], 1), _vm._v(" "), _c('td', [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "disabled": item.productNo.length > 5 ? false : true,
        "effect": "dark",
        "content": item.productNo,
        "placement": "top"
      }
    }, [_c('p', [_vm._v(_vm._s(item.productNo))])])], 1), _vm._v(" "), (_vm.moduleName !== 'supplier') ? _c('td', [_vm._v(_vm._s(_vm.getSingle(item.specification)))]) : _vm._e(), _vm._v(" "), (_vm.moduleName === 'supplier') ? _c('td', [_vm._v(_vm._s(item.cost))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unit ? item.unit : '--'))])]), _vm._v(" "), (_vm.moduleName !== 'supplier' && item.specification && item.specification.length > 1 && item.openTr) ? _c('tr', [_c('td', {
      staticStyle: {
        "background": "rgba(243,248,255,1)"
      },
      attrs: {
        "colspan": "8"
      }
    }, [_c('span', [_vm._v("选择规格：")]), _vm._v(" "), _vm._l((item.specification), function(it, i) {
      return _c('el-checkbox', {
        key: it.productId,
        on: {
          "change": function($event) {
            _vm.selectSubPro(item, it)
          }
        },
        model: {
          value: (it.specChecked),
          callback: function($$v) {
            _vm.$set(it, "specChecked", $$v)
          },
          expression: "it.specChecked"
        }
      }, [_vm._v("\n                   " + _vm._s(it.specification) + "\n                   ")])
    })], 2)]) : _vm._e()]
  }), _vm._v(" "), (_vm.haveList) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("暂无数据")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper clearfix"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(['contractApi', 'opportunityApi'].indexOf(this.moduleName) > -1) ? _c('span', {
    staticClass: "leftSpan"
  }, [_vm._v("已选产品：" + _vm._s(_vm.selectCopyId.length + _vm.selectIdArr.length))]) : _c('span', {
    staticClass: "leftSpan"
  }, [_vm._v("已选产品：" + _vm._s(_vm.idArr.length))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitProduct(_vm.fieldAttr)
      }
    }
  }, [_vm._v("确 定")])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38972352","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/select-product.vue
// module id = 1250
// module chunks = 82